import * as echarts from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { LineChart } from "echarts/charts";
import {
  DatasetComponent,
  GridComponent,
  TooltipComponent,
  LegendComponent,
} from "echarts/components";
import { format, setBgGraphic, graphics } from "./functions/echarts-functions";
import { resize1 } from "./functions/resize-functions";
import { iframeResizerContentWindow } from "iframe-resizer";

// This needs to be referenced so it isn't tree-shaken.
iframeResizerContentWindow; // tslint:disable-line no-unused-expression

echarts.use([
  CanvasRenderer,
  LineChart,
  DatasetComponent,
  GridComponent,
  TooltipComponent,
  LegendComponent,
]);

const controlls = {
  newCases: "false",
  yAxisType: "log",
  legend: "Confirmados",
  states: [],
  init: function () {
    this.initSelectors();
    this.initGroupButtons(document.querySelectorAll("button.newCases"));
    this.initGroupButtons(document.querySelectorAll("button.yAxisType"));
    this.initGroupButtons(document.querySelectorAll("button.legend"));
  },
  initSelectors: function (params) {
    const _self = this;
    //_self.states = topStatesConfirmed;

    const s1 = document.getElementById("state1");
    const s2 = document.getElementById("state2");
    _self.updateSelectors(false);

    s1.addEventListener("change", (event) => {
      _self.updateSelectors(true);
      covid19StateComparator.updateColors();
    });

    s2.addEventListener("change", (event) => {
      _self.updateSelectors(true);
      covid19StateComparator.updateColors();
    });
  },
  updateSelectors: function (readSelectors) {
    let stateListRef = statesConfirmed;
    if (this.legend != "Confirmados") {
      stateListRef = statesDeaths;
    }
    const s1 = document.getElementById("state1");
    const s2 = document.getElementById("state2");

    if (readSelectors) {
      this.states = [];
      this.states.push(s1.value);
      this.states.push(s2.value);
    }

    s1.options.length = 0;
    s2.options.length = 0;

    if (stateListRef.indexOf(this.states[0]) < 0) {
      const opt = document.createElement("option");
      opt.value = "";
      opt.text = "Seleccione la región";
      s1.options.add(opt);
    }

    if (stateListRef.indexOf(this.states[1]) < 0) {
      const opt = document.createElement("option");
      opt.value = "";
      opt.text = "Seleccione la región";
      s2.options.add(opt);
    }

    stateListRef.forEach((el) => {
      if (this.states[1] != el) {
        const s = this.states[0] == el;
        const opt = document.createElement("option");
        opt.value = el;
        opt.text = el;
        opt.selected = s;
        s1.options.add(opt);
      }
    });

    stateListRef.forEach((el) => {
      if (this.states[0] != el) {
        const s = this.states[1] == el;
        const opt = document.createElement("option");
        opt.value = el;
        opt.text = el;
        opt.selected = s;
        s2.options.add(opt);
      }
    });

    this.states = [];
    this.states.push(s1.value);
    this.states.push(s2.value);
  },
  initGroupButtons: function (buttons) {
    let _self = this;
    buttons.forEach((bt) => {
      bt.addEventListener("click", (event) => {
        buttons.forEach((el) => {
          el.classList.remove("active");
        });
        event.target.classList.add("active");

        if (event.target.classList.contains("newCases")) {
          _self.newCases = event.target.value;
        } else if (event.target.classList.contains("yAxisType")) {
          _self.yAxisType = event.target.value;
        } else if (event.target.classList.contains("legend")) {
          _self.legend = event.target.value;
          _self.updateSelectors(true);
        }

        covid19StateComparator.updateChart();
      });
    });
  },
};

const datasetOptions = [
  {
    source: newGraphData["Confirmados"],
  },
  {
    source: newGraphData["Fallecidos"],
  },
  {
    source: cumulativeGraphData["Confirmados"],
  },
  {
    source: cumulativeGraphData["Fallecidos"],
  },
];
const covid19StateComparator = {
  name: "echart_covid19_state_comparator",
  options: {
    animation: false,
    title: {
      show: false,
    },
    textStyle: {
      fontFamily: '"Montserrat", sans-serif',
    },
    tooltip: {
      show: true,
      trigger: "axis",
      formatter: function (vvv) {
        let tt = "<strong>" + controlls.legend + "</strong></br>";
        const f = vvv.filter((q) => q.color != "#999999");
        vvv
          .filter(
            (q) => q.color != "#999999" && q.value[q.seriesIndex + 1] != null
          )
          .forEach((vv) => {
            tt = tt.concat(vv.marker, vv.seriesName) + "</br>";
            if (controlls.legend == "Confirmados") {
              if (referenceDayConfirmed.hasOwnProperty(vv.seriesName)) {
                tt = tt.concat(
                  referenceDayConfirmed[vv.seriesName][vv.name].date
                );
              }
            } else {
              if (referenceDayDeaths.hasOwnProperty(vv.seriesName)) {
                tt = tt.concat(referenceDayDeaths[vv.seriesName][vv.name].date);
              }
            }

            const val = format(
              vv.value[vv.seriesIndex + 1],
              "decimal",
              0,
              null
            );
            tt = tt.concat(": ", val) + "</br>";
          });
        return tt;
      },
    },
    dataset: datasetOptions,
    grid: {
      right: 20,
      left: 60,
      top: 40,
      bottom: 20,
    },
    legend: {
      show: false,
    },
    xAxis: {
      type: "category",
    },
    yAxis: {
      type: "log",
      min: function (value) {
        return value.min;
      },
      max: function (value) {
        let valueMax = value.max;
        let exp = 0;
        while (valueMax > 1) {
          valueMax /= 10;
          exp++;
        }
        return Math.pow(10, exp);
      },
    },
    series: datasetOptions[2].source[0].slice(1).map(function (el, idx) {
      return {
        datasetIndex: 2,
        type: "line",
        lineStyle: {
          width: 1,
        },
        encode: {
          seriesName: [idx + 1],
          x: 0,
          y: idx + 1,
        },
        // showSymbol: false
      };
    }),
  },
  init: function () {
    graphics[this.name] = echarts.init(document.getElementById(this.name));
    const lineProps = this.getLineProps();
    this.options.color = lineProps.color;

    graphics[this.name].setOption(this.options);
    setBgGraphic(this.name);
    this.initEvents();
    resize1();
  },
  initEvents: function () {
    const _self = this;
    graphics[this.name].off("mouseover");
    graphics[this.name].on(
      "mouseover",
      {
        componentType: "series",
      },
      function (params) {
        graphics[_self.name].setOption(_self.getLineProps(params.seriesIndex));
      }
    );
    graphics[this.name].off("mouseout");
    graphics[this.name].on(
      "mouseout",
      {
        componentType: "series",
      },
      function (params) {
        graphics[_self.name].setOption(_self.getLineProps());
      }
    );
  },
  getLineProps: function (iidx) {
    const sColors = ["#12809e", "#0db407"];
    const statesLst = this.getRelatedDataset(this.getDatasetIndex())[0].slice(
      1
    );
    const result = statesLst.map((el, idx) => {
      const ii = controlls.states.indexOf(el);
      return {
        color: ii >= 0 ? sColors[ii] : idx == iidx ? "#ff0000" : "#999999",
        zlevel: ii >= 0 ? 2 : idx == iidx ? 1 : 0,
        lineWidth: ii >= 0 ? 3 : idx == iidx ? 3 : 1,
      };
    });

    return {
      color: result.map((el) => el.color),
      series: result.map((el) => {
        return {
          zlevel: el.zlevel,
          lineStyle: {
            width: el.lineWidth,
          },
        };
      }),
    };
  },
  getDatasetIndex: function () {
    let datasetIdx = 2;

    if (controlls.newCases == "true" && controlls.legend == "Confirmados") {
      datasetIdx = 0;
    } else if (
      controlls.newCases == "true" &&
      controlls.legend == "Fallecidos"
    ) {
      datasetIdx = 1;
    } else if (
      controlls.newCases == "false" &&
      controlls.legend == "Fallecidos"
    ) {
      datasetIdx = 3;
    }
    return datasetIdx;
  },
  getRelatedDataset: function (idx) {
    return datasetOptions[idx].source;
  },
  updateColors: function () {
    graphics[this.name].setOption(this.getLineProps());
  },
  updateChart: function () {
    const datasetIdx = this.getDatasetIndex();

    const s = this.getRelatedDataset(datasetIdx)[0]
      .slice(1)
      .map(function (el, idx) {
        return {
          datasetIndex: datasetIdx,
          type: "line",
          encode: {
            seriesName: [idx + 1],
            x: 0,
            y: idx + 1,
          },
        };
      });
    this.options.series = s;
    this.options.yAxis.type = controlls.yAxisType;
    graphics[this.name].setOption(this.options, {
      notMerge: true,
    });

    graphics[this.name].setOption({
      yAxis: {
        type: controlls.yAxisType,
        min: function (value) {
          if (controlls.yAxisType == "log") {
            return 1;
          } else {
            return 0;
          }
        },
        max: function (value) {
          let res = value.max;
          if (controlls.yAxisType == "log") {
            let valueMax = value.max;
            let exp = 0;
            while (valueMax > 1) {
              valueMax /= 10;
              exp++;
            }
            res = Math.pow(10, exp);
          } else {
            res = Math.round(value.max * 1.1);
          }
          return res;
        },
      },
    });

    graphics[this.name].setOption(this.getLineProps());
  },
};

controlls.init();
covid19StateComparator.init();
